class classDdl {
    constructor(value = null, options = [], disabled = true, error = false) {
        this.value = value;
        this.options = options;
        this.disabled = disabled;
        this.error = error;
    }   
};
export default classDdl;
